<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title">{{title}}</h4>
    </div>
    <div class="card-body">
      <ul class="list-unstyled team-members">
        <li>
          <div class="row" v-for="accountUser in users" v-bind:key="accountUser.id">
            <div class="col-2 col-md-2">
              <avatar class="avatar" :size="30" :username="accountUser.displayName"></avatar>
            </div>
            <div class="col-md-6 col-6">
              {{accountUser.displayName}}
              <span v-if="accountUser.id === user.id">
                <i class="fa fa-star" style="color: gold;"></i>
              </span>
              <br>
              <span>
                <small>{{accountUser.role}}</small>
              </span>
            </div>

            <div v-if="accountUser.id === user.id" class="col-md-4 col-4 text-right">
              <p-button size="sm" type="info" v-if="canEditAccountUser(accountUser)" outline icon round @click="showAccountUserEditDialog(accountUser)">
                <i class="fa fa-pencil"></i>
              </p-button>
              <p-button size="sm" type="danger" v-if="canEditAccountUser(accountUser)" outline icon round @click="showAccountUserDeleteDialog(accountUser)">
                <i class="fa fa-trash-o"></i>
              </p-button>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="card-footer">
      <div class="text-right">
        <p-button type="default" v-if="canInviteUsers()" outline @click="showInviteUserDialog = true">
          Invite user &nbsp;<i class="fa fa-plus"></i>
        </p-button>
      </div>

      <modal :show.sync="showInviteUserDialog"
              class="modal-primary"
              :show-close="true"
              headerClasses="justify-content-center"
              type="mini">
        <div slot="header" class="modal-profile ml-auto mr-auto">
          <i class="fa fa-user-plus"></i>
        </div>

        <p>Invite another user to join your account.</p>
        <form>
          <fg-input type="email"
                    :required="true"
                    name="emailAddress"
                    data-vv-as="email address"
                    data-vv-delay="1000"
                    label="Email Address"
                    placeholder="Email Address"
                    v-model="accountInvitationForm.fields.emailAddress"
                    v-validate="accountInvitationForm.validators.emailAddress"
                    :error="fieldError('emailAddress')">
            </fg-input>


            <div class="form-group">
              <label for="role" class="control-label">Role <span>*</span></label>
              <el-select class=""
                          name="role"
                          size="large"
                          placeholder="User role"
                          v-model="accountInvitationForm.fields.role">
                <el-option v-for="option in getInvitableRoles()"
                            class="select-default"
                            :value="option.value"
                            :label="option.label"
                            :key="option.label">
                </el-option>
              </el-select>
            </div>
        </form>

        <div class="alert alert-warning" v-if="accountInvitationForm.error">
          Error inviting user: {{ accountInvitationForm.error }}
        </div>

        <template slot="footer">
          <div class="left-side">
            <p-button type="default"
                      link
                      @click="showInviteUserDialog = false">
            Cancel &nbsp;<i class="fa fa-times"></i>
          </p-button>
          </div>
          <div class="divider"></div>
          <div class="right-side">
            <p-button type="primary"
                      link
                      :disabled="accountInvitationCreating"
                      @click="validateAccountInvitation()">
              <span v-if="!accountInvitationCreating">
                Send &nbsp;<i class="fa fa-paper-plane"></i>
              </span>
              <span v-if="accountInvitationCreating">
                Please wait &nbsp;<i class=" fa fa-spin fa-circle-o-notch"></i>
              </span>
            </p-button>
          </div>
        </template>
      </modal>
    </div>
  </div>
</template>
<script>
import Avatar from "vue-avatar";
import swal from "sweetalert2";
import _ from "lodash";
import { Button, Modal } from "src/components/UIComponents";
import { Select, Option } from "element-ui";

export default {
  components: {
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    Avatar,
    Modal
  },
  data() {
    return {
      showInviteUserDialog: false,
      accountInvitationCreating: false,
      accountInvitationForm: {
        fields: {
          emailAddress: "",
          role: null
        },
        validators: {
          emailAddress: {
            required: true,
            email: true
          }
        },
        error: null
      }
    };
  },
  computed: {
    user: function() {
      return this.$auth.user();
    },
    account: function() {
      return this.$ls.get("account");
    }
  },
  props: {
    users: Array,
    title: String
  },
  methods: {
    validateAccountInvitation() {
      this.$validator.validateAll().then(isValid => {
        this.$emit("on-submit", this.registerForm, isValid);
        if (isValid) {
          this.createAccountInvitation();
        }
      });
    },
    createAccountInvitation() {
      this.accountInvitationCreating = true;
      const body = {
        emailAddress: this.accountInvitationForm.fields.emailAddress,
        role: this.accountInvitationForm.fields.role
      };
      this.axios
        .post(`/v1/accounts/${this.account.id}/invitations`, body)
        .then(response => {
          this.accountInvitationCreating = false;
          this.$notify({
            message: `Invitation sent to ${body.emailAddress}`,
            timeout: 2000,
            icon: "fa fa-paper-plane",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success"
          });

          this.showInviteUserDialog = false;
        })
        .catch(error => {
          this.accountInvitationCreating = false;
          let errorMessage = "Failed to create account invitation";
          console.log("error: ", error);
          if (error.response.data) {
            if (error.response.data.message) {
              errorMessage = error.response.data.message;
            } else if (error.response.data.status) {
              errorMessage += ` (status code ${error.response.data.status})`;
            }
          }

          this.accountInvitationForm.error = errorMessage;
        });
    },
    fieldError(fieldName) {
      // clientside
      if (this.errors.first(fieldName)) {
        return this.errors.first(fieldName);
      }

      // serverside
      const fieldError = _.find(this.validationErrors, item => {
        return _.includes(item.field, fieldName);
      });

      if (!fieldError) {
        return false;
      } else if (fieldError.messages) {
        return fieldError.messages;
      } else {
        return true;
      }
    },
    getInvitableRoles() {
      let roles = [];
      const currentAccountUser = _.find(this.users, accountUser => {
        return this.user.id === accountUser.id;
      });

      const allRoles = {
        owner: {
          value: "owner",
          label: "Owner"
        },
        manager: {
          value: "manager",
          label: "Manager"
        },
        viewer: {
          value: "viewer",
          label: "Viewer (read only)"
        }
      };

      if (currentAccountUser.role === "owner") {
        roles = [allRoles.owner, allRoles.manager, allRoles.viewer];
      } else if (currentAccountUser.role === "manager") {
        roles = [allRoles.manager, allRoles.viewer];
      } else if (currentAccountUser.role === "viewer") {
        roles = [];
      }

      return roles;
    },
    canInviteUsers() {
      let canInvite = false;
      const currentAccountUser = _.find(this.users, accountUser => {
        return this.user.id === accountUser.id;
      });

      const roles = ["manager", "owner"];

      if (_.includes(roles, currentAccountUser.role)) {
        canInvite = true;
      }

      return canInvite;
    },
    canEditAccountUser(accountUser) {
      let canEdit = false;

      const currentAccountUser = _.find(this.users, accountUser => {
        return this.user.id === accountUser.id;
      });

      if (currentAccountUser.role === "owner") {
        canEdit = true;
      } else if (currentAccountUser.role === "manager") {
        if (accountUser.role === "manager" || accountUser.role === "viewer") {
          canEdit = true;
        }
      } else if (currentAccountUser.role === "viewer") {
        canEdit = false;
      }

      return canEdit;
    },
    showAccountUserDeleteDialog(accountUser) {
      swal({
        title: "Remove account user",
        type: "warning",
        showCancelButton: true,
        text: "This user will be removed from your account",
        confirmButtonText: "Remove user",
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !swal.isLoading(),
        preConfirm: selectedRole => {
          const requestBody = {
            role: selectedRole
          };

          return this.axios
            .delete(
              `/v1/accounts/${this.account.id}/users/${accountUser.id}`,
              requestBody
            )
            .then(response => {
              return true;
            })
            .catch(error => {
              let errMsg = "Error removing account user";

              if (error.response && error.response.data) {
                if (error.response.data.message) {
                  errMsg += `: ${error.response.data.message}.`;
                }

                // try to do field-level error handling
                if (
                  error.response.data.errors &&
                  error.response.data.errors.length > 0
                ) {
                  _.each(error.response.data.errors, err => {
                    if (err.messages && err.messages.length > 0) {
                      errMsg += `<br>${err.messages[0]}`;
                    }
                  });
                }
              }
              swal.showValidationMessage(errMsg);
            });
        }
      }).then(result => {
        if (result.value) {
          swal({
            type: "success",
            title: "Account user removed"
          });
        }
      });
    },
    showAccountUserEditDialog(accountUser) {
      const roles = {
        owner: "Owner",
        manager: "Manager",
        viewer: "Viewer (read only)"
      };
      swal({
        title: "Update account user",
        type: "question",
        input: "select",
        inputOptions: roles,
        showCancelButton: true,
        text: "Choose a new role for this user",
        confirmButtonText: "Update",
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !swal.isLoading(),
        preConfirm: selectedRole => {
          const requestBody = {
            role: selectedRole
          };

          return this.axios
            .patch(
              `/v1/accounts/${this.account.id}/users/${accountUser.id}`,
              requestBody
            )
            .then(response => {
              return true;
            })
            .catch(error => {
              let errMsg = "Error updating account user";

              if (error.response && error.response.data) {
                if (error.response.data.message) {
                  errMsg += `: ${error.response.data.message}.`;
                }

                // try to do field-level error handling
                if (
                  error.response.data.errors &&
                  error.response.data.errors.length > 0
                ) {
                  _.each(error.response.data.errors, err => {
                    if (err.messages && err.messages.length > 0) {
                      errMsg += `<br>${err.messages[0]}`;
                    }
                  });
                }
              }
              swal.showValidationMessage(errMsg);
            });
        }
      }).then(result => {
        if (result.value) {
          swal({
            type: "success",
            title: "Account user updated"
          });
        }
      });
    }
  }
};
</script>
<style>
</style>
